import { Directive, HostListener } from "@angular/core";

@Directive({
  selector: 'input[latinTextOnly]',
  standalone: false
})
export class LatinTextOnlyDirective {

  private controlKeys = [
    'Backspace', 'Delete', 'Tab',
    'ArrowLeft', 'ArrowRight', 'Home', 'End'
  ];

  private allowedSpecialChars = new Set([
    ' ', '.', ',', '-', '_', '@', '#', '$', '%',
    '!', '?', ':', ';', '\'', '"', '(', ')', '&',
    '[', ']', '{', '}', '/', '\\', '+', '=', '*',
    '^', '<', '>', '`', '~'
  ]);

  @HostListener('beforeinput', ['$event'])
  onBeforeInput(event: InputEvent) {

    if (event.inputType?.startsWith('insertComposition')) {
      event.preventDefault();
      return;
    }

    if (!event.data) {
      return;
    }

    for (const ch of event.data) {
      if (!this.isAllowedChar(ch)) {
        event.preventDefault();
        return;
      }
    }
  }
  
@HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;

    input.value = [...input.value]
      .filter(ch => this.isAllowedChar(ch))
      .join('');
  }

  private isAllowedChar(ch: string): boolean {
    if (ch.toLowerCase() !== ch.toUpperCase()) {
      return true;
    }

    if (ch >= '0' && ch <= '9') {
      return true;
    }

    if (this.allowedSpecialChars.has(ch)) {
      return true;
    }

    return false;
  }
}
